import { ReallocateAccount } from 'actions';

const initialState = {
  currentPage: 0,
  selectedAccount: [],
  selectedTargetPort: [],
  selectedTargetAcc: [],
  targetTypePorts: true,
  confirmedPort: false,
  currency: 'CAD',
  commission: '',
  tableData: [],
  loading: false,
  cashAmount: '',
  cashAdd: true,
  showUnmatchedWarning: false,
};

// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case ReallocateAccount.REALLOCATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ReallocateAccount.REALLOCATE_SAVE:
      return {
        ...state,
        tableData: action.data,
        loading: false,
      };
    case ReallocateAccount.REALLOCATE_DELETE:
      return {
        ...state,
        tableData: null,
      };
    case ReallocateAccount.REALLOCATE_UPDATE_PARAMETER:
      return {
        ...state,
        [action.field]: action.value,
      };

    case ReallocateAccount.REALLOCATE_ADD_ITEM:
      return {
        ...state,
        [action.field]: [...state[action.field], action.value],
      };
    case ReallocateAccount.REALLOCATE_REMOVE_ITEM:
      return {
        ...state,
        [action.field]: state[action.field].filter(
          (item) => item.id !== action.value
        ),
      };
    case ReallocateAccount.REALLOCATE_RESET:
      return initialState;

    default:
      return state;
  }
}
